import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/views/home/index.vue';
import DocPage from '@/views/doc/index.vue';
import JiZhangPage from '@/views/jizhang/index.vue';
Vue.use(Router);
export default new Router({
    mode: 'history', // 或者 'history' 如果你想要使用HTML5 history模式
    routes: [

        {
            path: '/jizhang',
            name: 'JiZhangPage',
            component: JiZhangPage,
        },
        {
            path: '/:objToken',
            name: 'DocPage',
            component: DocPage
        },

        {
            path: '/',
            name: 'HomePage',
            component: HomePage,
        },
        // 添加通配符路由以处理所有未定义的路径
        {
            path: '*',
            redirect: '/'
        }
    ]
});
